import React from "react";
import styled from "styled-components";
import {PuffLoader} from "react-spinners";
import classnames from "classnames";

function Spinner({ loading, children }) {

  return (
      <SpinnerWrapper className={classnames({ loading })}>
        <div className="spinner-container">{children}</div>
        {
          loading && <div className="spinner-loading">
            <PuffLoader loading={loading} color="#fff"/>
          </div>
        }
      </SpinnerWrapper>
  )
}
export default Spinner;

const SpinnerWrapper = styled.div`
  position: relative;
  
  .spinner-container {
    transition: all .35s ease;
    min-height: 200px;
  }

  &.loading .spinner-container {
    filter: blur(3px);
  }

  .spinner-loading {
    position: absolute;
    left: 0;top: 0;right: 0;bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }
`;


